import type { IChapterGivingAccount } from "@dc-ireland/shared"
import { isStripeGivingEnabled } from "./featureFlags"

export const giveConfig = {
  stripeUrl: import.meta.env.VITE_GIVE_STRIPE_URL ?? import.meta.env.VITE_GIVE_CARD_URL ?? "",
  contactEmail: "info@dominioncity.ie",
  defaultReference: "Donation",
} as const

export const hasStripePayment = () =>
  isStripeGivingEnabled() && Boolean(giveConfig.stripeUrl.trim())

export const showStripeGivingOption = () => isStripeGivingEnabled()

const buildMailtoLink = (subject: string, body: string) => {
  const params = new URLSearchParams({ subject, body })
  return `mailto:${giveConfig.contactEmail}?${params.toString()}`
}

export const bankDetailsRequestMailto = (chapterName?: string) => {
  const target = chapterName ? `Dominion City ${chapterName}` : "Dominion City Ireland CLG"
  return buildMailtoLink(
    chapterName ? `${chapterName} Bank Transfer Details Request` : "Bank Transfer Details Request",
    `Hello Dominion City Ireland team,

I would like to request the bank transfer details for giving to ${target}.

Name:
Email:
Phone (optional):

Thank you.`,
  )
}

export const accountReference = (account: IChapterGivingAccount) =>
  account.reference?.trim() || giveConfig.defaultReference

export const hasBankDetails = (account: IChapterGivingAccount) =>
  Boolean(account.bankName?.trim() || account.iban?.trim() || account.accountNumber?.trim())

export const hasPaypalUrl = (account: IChapterGivingAccount) => Boolean(account.paypalUrl?.trim())

export const hasSumupUrl = (account: IChapterGivingAccount) => Boolean(account.sumupUrl?.trim())

export const givingMethodsLabel = (account: IChapterGivingAccount) => {
  const methods: string[] = []
  if (hasSumupUrl(account)) methods.push("SumUp")
  if (hasPaypalUrl(account)) methods.push("PayPal")
  if (hasBankDetails(account)) methods.push("Bank transfer")
  return methods.length > 0 ? methods.join(" · ") : "Details coming soon"
}
